import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.color || colors.blue_main;

  return (
    <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path fill={color} d="M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z"></path>
    </svg>
  );
}

export default Icon;
